<template>
  <div>
    <template v-if="!data.hasOwnProperty('param')">
      <b-tabs>
        <b-tab v-for="(values, key) in data" :key="key" :title="key">
          <service-template-tab :items="values" v-bind="$attrs" v-on="$listeners" />
        </b-tab>
      </b-tabs>
    </template>
    <template v-else>
      <b-row v-for="(value, key) in data" :key="key" class="mb-2">
        <b-col v-if="key === 'timer'" sm="1"><strong>{{ fieldName[key] }}</strong></b-col>
        <b-col v-else sm="2"><strong>{{ fieldName[key] }}</strong></b-col>
        <b-col>
          <template v-if="key === 'param'">
            <json-view :parsedData="items[key]" v-model="data[key]" />
          </template>
          <template v-else>
            <b-form-input v-if="key === 'desc'" type="text" v-model="data[key]" />
            <b-form-select v-else-if="key === 'isopen'" :options="boolOptions" v-model="data[key]" />
            <b-form-select v-else-if="key === 'sign_check'" :options="boolOptions" v-model="data[key]" />
            <b-form-select v-else-if="key === 'return_type'" :options="returnTypeOptions" v-model="data[key]" />
            <template v-else-if="key === 'data_tag'">
              <b-form-input v-if="data['return_type'] !== 'FILE'" type="text" v-model="data[key]" />
            </template>
            <template v-else-if="key === 'table_conf'">
              <template v-if="data['return_type'] === 'TABLE'">
                <table-conf :items="data[key]" @add="addTableConf" @del="delTableConf($event)" />
              </template>
            </template>
            <template v-else-if="key === 'tag_desc'">
              <tag-desc-conf :items="data[key]" @new="addTagDesc" @remove="delTagDesc($event)" />
            </template>
            <template v-else>
              <b-row class="mb-2">
                <b-col v-for="(field, index) in timerFields" :key="index">
                  {{ field }}
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col v-for="(field, index) in timerFields" :key="index">
                  <b-form-input v-if="field === 'start_date' || field === 'end_date'" type="date" v-model="data[key][field]" required />
                  <b-form-input v-else type="text" v-model="data[key][field]" required />
                </b-col>
              </b-row>
            </template>
          </template>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'service-template-tab',
  props: ['items'],
  components: {
    'service-template-tab': () => import('./Tab.vue'),
    'json-view': () => import('./JsonView.vue'),
    'table-conf': () => import('./TableConf.vue'),
    'tag-desc-conf': () => import('./TagDescConf.vue')
  },
  data () {
    return {
      data: this.items,
      fieldName: {
        desc: '描述',
        isopen: '开放使用',
        param: '参数',
        timer: '定时配置',
        return_type: '返回值类型',
        data_tag: 'Data Tag',
        table_conf: '表头配置',
        tag_desc: '标签',
        sign_check: '开启签名校验'
      },
      boolOptions: [
        {text: '是', value: true},
        {text: '否', value: false}
      ],
      returnTypeOptions: [
        {text: '数据-JSON', value: 'JSON'},
        {text: '数据-表格', value: 'TABLE'},
        {text: '文件', value: 'FILE'}
      ],
      timerFields: ['second', 'minute', 'hour', 'day', 'month', 'year', 'week', 'day_of_week', 'start_date', 'end_date', 'timezone'],
      timerFieldName: {
        'second': 'Second',
        'minute': 'Minute',
        'hour': 'Hour',
        'day': 'Day',
        'month': 'Month',
        'year': 'Year',
        'week': 'Week',
        'day_of_week': 'Day Of Week',
        'start_date': 'Start date',
        'end_date': 'End date',
        'timezone': 'Timezone'
      }
    }
  },
  watch: {
    items (val) {
      this.data = val
    },
    'items.return_type': {
      handler: function (newVal, oldVal) {
        if (newVal === 'FILE') {
          this.items.data_tag = ''
        }
        if (newVal !== 'TABLE') {
          this.items.table_conf = []
        } else {
          this.items.table_conf = [{field: '', name: ''}]
        }
      }
    }
  },
  methods: {
    addTableConf () {
      this.items.table_conf.push({field: '', name: ''})
    },
    delTableConf (idx) {
      this.items.table_conf.splice(idx, 1)
    },
    addTagDesc () {
      this.items.tag_desc.push({name: '', tag: ''})
    },
    delTagDesc (idx) {
      this.items.tag_desc.splice(idx, 1)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Tab.vue?56f6b95c